/* unplugin-vue-components disabled */import script from "./statistic.vue?vue&type=script&setup=true&name=TaskStatistic&lang=js"
export * from "./statistic.vue?vue&type=script&setup=true&name=TaskStatistic&lang=js"

import "./statistic.vue?vue&type=style&index=0&id=4631e3e7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4631e3e7"]])

export default __exports__